import { useFormContext } from 'react-hook-form';
import styles from './RadioButton.module.scss';
import { useFieldValidity } from '../../../pages/ApplicationV3/hooks/useFieldValidity';
import sanitize from 'sanitize-html';

export const Cypress_DATA = {
  radioButton: 'base-radio-button',
  radioWrapper: 'base-radio-wrapper',
  radioInput: 'base-radio-input',
  customRadio: 'base-custom-radio',
  labelText: 'base-label-text',
  errorText: 'base-error-text',
};

export interface RadioButtonOptionProps<T> {
  id: string;
  value: T;
  displayValue: string;
  title?: string;
  sortOrder?: number;
  disabled?: boolean;
  dataCy?: string;
}

interface RadioButtonProps<T extends { toString(): string }> {
  id?: string;
  name: string;
  options: RadioButtonOptionProps<T>[];
  header?: string;
  selected?: T;
  disabled?: boolean;
  isValid?: boolean;
  isDirty?: boolean;
  dataCy?: string;
}
const RadioButton = <T extends { toString(): string }>({
  options,
  name,
  header,
  disabled,
  dataCy,
}: RadioButtonProps<T>) => {
  const { register, watch } = useFormContext();
  const { error } = useFieldValidity(name);
  const value = watch(name) || '';

  return (
    <div
      className={styles.radiobuttonContainer}
      data-cy={dataCy || Cypress_DATA.radioButton}
    >
      {header && (
        <div
          className={styles.header}
          dangerouslySetInnerHTML={{ __html: sanitize(header) }}
        />
      )}
      {(options || []).map((option: RadioButtonOptionProps<T>) => (
        <label
          className={styles.radioWrapper}
          htmlFor={option.id}
          key={option.id}
          data-cy={Cypress_DATA.radioWrapper}
        >
          <input
            type="radio"
            id={option.id}
            {...register(name)}
            value={option.value.toString()}
            checked={String(value) === option.value.toString()}
            disabled={option.disabled || disabled}
            className={styles.radioInput}
            title={option.title}
            data-cy={option.dataCy || Cypress_DATA.radioInput}
          />
          <p
            className={styles.customRadio}
            data-cy={Cypress_DATA.customRadio}
          ></p>
          <p className={styles.labelText} data-cy={Cypress_DATA.labelText}>
            {option.displayValue}
          </p>
        </label>
      ))}
      {error && (
        <span className={styles.errorText} data-cy={Cypress_DATA.errorText}>
          {error.message}
        </span>
      )}
    </div>
  );
};

export default RadioButton;
